import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import UsersPanel from './components/UsersPanel';
import Manifest from './pages/Manifest';
import SMS from './pages/SMS';
import Email from './pages/Email';
import Reports from './pages/Reports';
import Graphs from './pages/Graphs';
import TwoFactorSetup from './pages/TwoFactorSetup';
import Guests from './pages/Guests';
// import GuestDetail from './pages/GuestDetail';
import Tours from './pages/Tours';
import OperationsTours from './pages/OperationsTours';
import Changelog from './pages/Changelog';
import NotFound from './pages/NotFound';

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings/*"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin']}>
                  <Settings />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="users" replace />} />
              <Route path="users" element={<UsersPanel />} />
              <Route path="changelog" element={<Changelog />} />
              <Route path="helper-scripts" element={<Navigate to="/settings/users" replace />} />
            </Route>
            <Route path="/users" element={<Navigate to="/settings/users" replace />} />
            <Route
              path="/manifest"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin']}>
                  <Manifest />
                </PrivateRoute>
              }
            />
            <Route
              path="/operations/tours"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin']}>
                  <OperationsTours />
                </PrivateRoute>
              }
            />
            <Route
              path="/sms"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin']}>
                  <SMS />
                </PrivateRoute>
              }
            />
            <Route
              path="/email"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin']}>
                  <Email />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin']}>
                  <Reports />
                </PrivateRoute>
              }
            />
            <Route
              path="/graphs"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin', 'user']}>
                  <Graphs />
                </PrivateRoute>
              }
            />
            <Route
              path="/guests"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin', 'user']}>
                  <Guests />
                </PrivateRoute>
              }
            />
            {/* GuestDetail route commented out - page doesn't exist yet */}
            {/* <Route
              path="/guests/:guestId"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin', 'user']}>
                  <GuestDetail />
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/tours"
              element={
                <PrivateRoute allowedRoles={['superadmin', 'admin', 'user']}>
                  <Tours />
                </PrivateRoute>
              }
            />
            <Route
              path="/2fa-setup"
              element={
                <PrivateRoute>
                  <TwoFactorSetup />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

